import type {
    EditorReactComponent,
    Behaviors as ManifestBehaviors,
    EditorElement as ManifestEditorElement,
    Elements as ManifestElements,
    ElementItem as ManifestElementItem,
    Data as ManifestData,
    Presets as ManifestPresets,
    DataOverrides as ManifestDataOverrides,
    ElementsDefaults as ManifestElementDefaults,
    CSS_PROPERTIES
} from '@wix/component-protocol/schema'
import type {CssCustomPropertyItem, CssPropertyItem} from '@wix/ambassador-devcenter-v1-component-type-data/types'

export namespace Builder {
    export type Manifest = EditorReactComponent
    export type ResolvedManifest = EditorReactComponent
    export type ResolvedEditorElement = ManifestEditorElement
    export type StyleType = (typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE)[keyof typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE]
    export type Behaviors = ManifestBehaviors
    export type Elements = ManifestElements
    export type ElementItem = ManifestElementItem
    export type Data = ManifestData
    export type DataType = NonNullable<ManifestData>[string]['dataType']
    export type Presets = NonNullable<ManifestPresets>
    export type PresetItem = NonNullable<Presets>[string]
    export type DataItem = NonNullable<Data>[string]
    export type DataItemOverrides = NonNullable<ManifestDataOverrides>
    export type ElementsDefaults = NonNullable<ManifestElementDefaults>
    export type StyleOverrides = Record<string, CssPropertyItem | CssCustomPropertyItem>
    export interface ResolvedElements {
        [key: string]: ManifestEditorElement & {
            elements?: ResolvedElements
        }
    }
}
interface AppData {
    componentId: string
    appDefinitionId: string
    widgetId: string
}
interface BuilderComponentsObject {
    register(identifier: string, manifest: Builder.Manifest): never
    getCompAppData(componentType: string): AppData | undefined
}

export interface BuilderObject {
    components: BuilderComponentsObject
}

export interface NestedDataPathSegment {
    type: 'simple' | 'array'
    key: string
    _id?: string
}

export interface OverrideOrDefaultData {
    type: string
    prop: string
    value: any
    metaData: any
    whereToWriteInDM: string
    path?: string[]
    nestedDataPath?: NestedDataPathSegment[]
}

export const SYSTEM_CONTAINER_TYPE = 'wixSystemElements.InternalContainer'
